export const GROUP_NAME = 'input-checkbox'

export enum Variants {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
}

export const DEFAULT_VARIANT = Variants.Primary

export enum Colors {
  Blue = 'blue',
  Green = 'green',
  Pink = 'pink',
  Purple = 'purple',
  Yellow = 'yellow',
}

export const DEFAULT_COLOR = Colors.Pink
